import insane from 'insane'
import { marked } from 'marked'

import * as styles from './markdown.styles'

type Props = {
  input?: string
}

export const Markdown = ({ input = '' }: Props) => (
  <div
    dangerouslySetInnerHTML={{
      __html: insane(marked(input)),
    }}
    css={styles.root}
    data-testid="markdown"
  />
)
